<script setup lang="ts">
import type { ValidationState } from 'bootstrap-vue-next';
import { BCard, BForm, BFormGroup, BFormInput } from 'bootstrap-vue-next';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

import { fetchEditableUser } from '~/api/users';
import LoadingButton from '~/common/components/LoadingButton.vue';

const router = useRouter();

const userHandle = ref('');
const loading = ref(false);
const valid = ref<ValidationState>(null);

const manageUser = async (): Promise<void> => {
  if (loading.value) {
    return;
  }

  valid.value = null;
  loading.value = true;

  try {
    const { id } = await fetchEditableUser(userHandle.value.trim());
    void router.push({ name: 'user-edit', params: { userId: id } });
  } catch {
    valid.value = false;
  } finally {
    loading.value = false;
  }
};
</script>

<template>
  <BCard
    title="Manage a user"
    class="h-100"
  >
    <p class="text-body-secondary">
      Enter a user ID or username to edit a contributor's profile or remove them.
    </p>
    <BForm @submit.prevent="manageUser">
      <BFormGroup
        :state="valid"
        invalid-feedback="No user found with that ID or username."
      >
        <div class="d-flex gap-2 align-items-start">
          <BFormInput
            v-model="userHandle"
            placeholder="User ID or username"
            required
            :state="valid"
          />
          <LoadingButton
            type="submit"
            variant="outline-primary"
            class="text-nowrap"
            :loading="loading"
          >
            Edit user
          </LoadingButton>
        </div>
      </BFormGroup>
    </BForm>
  </BCard>
</template>
